import { ReactElement } from 'react';
import { DashboardContainer } from '../../../modules/common/dashboard/DashboardContainer';
import { ColumnLayout } from '../../../modules/common/layouts/columnLayout/ColumnLayout';
import { DatasetDetailsPreviewHeaderContainer } from '../../modules/datasets/containers/DatasetDetailsPreviewHeader.container';
import { DatasetDetailsPreviewView } from './datasetsDetails/DatasetDetailsPreview.view';

export const PreviewView = (): ReactElement => (
  <DashboardContainer>
    <ColumnLayout size='none'>
      <DatasetDetailsPreviewHeaderContainer />
      <DatasetDetailsPreviewView />
    </ColumnLayout>
  </DashboardContainer>
);
